import script from "./AppToast.vue?vue&type=script&setup=true&lang=js"
export * from "./AppToast.vue?vue&type=script&setup=true&lang=js"

import "./AppToast.vue?vue&type=style&index=0&id=2be0e65e&lang=scss"

const __exports__ = script;

export default __exports__